import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const CurrencyContext = createContext(null);

const STORAGE_KEY = "lb_currency";

const DEFAULT_HERO = "https://images.unsplash.com/photo-1612817288484-6f916006741a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHw0fHxlbGVnYW50JTIwc2tpbmNhcmUlMjBwcm9kdWN0c3xlbnwwfHx8fDE3ODQyOTkyMzB8MA&ixlib=rb-4.1.0&q=85";

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(() => localStorage.getItem(STORAGE_KEY) || "CVE");
  const [rate, setRate] = useState(100);
  const [whatsapp, setWhatsapp] = useState("+351916389631");
  const [heroImage, setHeroImage] = useState(DEFAULT_HERO);
  const [heroTitle, setHeroTitle] = useState("");
  const [heroSubtitle, setHeroSubtitle] = useState("");

  const loadSettings = useCallback(async () => {
    try {
      const { data } = await api.get("/public/settings");
      if (data?.exchange_rate_cve_per_eur) setRate(data.exchange_rate_cve_per_eur);
      if (data?.whatsapp_number) setWhatsapp(data.whatsapp_number);
      setHeroImage(data?.hero_image_base64 && data.hero_image_base64.length > 10 ? data.hero_image_base64 : DEFAULT_HERO);
      setHeroTitle(data?.hero_title || "");
      setHeroSubtitle(data?.hero_subtitle || "");
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { loadSettings(); }, [loadSettings]);

  const setAndPersist = (c) => {
    localStorage.setItem(STORAGE_KEY, c);
    setCurrency(c);
  };

  const format = (cveAmount) => {
    const amt = Number(cveAmount || 0);
    if (currency === "EUR") {
      const eur = amt / (rate || 1);
      return new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR", maximumFractionDigits: 2 }).format(eur);
    }
    return `${new Intl.NumberFormat("pt-PT", { maximumFractionDigits: 0 }).format(Math.round(amt))} CVE`;
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency: setAndPersist, rate, whatsapp, heroImage, heroTitle, heroSubtitle, reload: loadSettings, format }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
